import {Insta} from "./Instagram"
(function() {
    const $instaBlock = document.querySelector('#instagram-block')
    if($instaBlock) new Insta($instaBlock)
})()